// extracted by mini-css-extract-plugin
module.exports = {"container":"company-module--container--2nPBS","wrapper":"company-module--wrapper--2NwL6","image":"company-module--image--3ccgy"};